<template>
  <app-page>
    <div class="ticket-template-empty">
      <app-state-overlay state="empty" title="Diese Seite ist noch leer." :offset-top="0" />
    </div>
  </app-page>
</template>

<script>
export default {};
</script>

<style scoped>
.ticket-template-empty {
  position: relative;
  min-height: 240px;
}
</style>
